import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default from 'react';
import styled from 'styled-components';
import '../../App.css.js';
import LandingHeaderNormal from './landing-header-ecosystem.component.js';
import LandingHeaderNormal$1 from './landing-header-normal-old.component.js';
import LandingHeaderNormal$2 from './landing-header-normal.component.js';
import LandingHeaderSmall from './landing-header-small.component.js';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Div = styled.div.withConfig({
  displayName: "landing-headercomponent__Div",
  componentId: "sc-11etiw5-0"
})(["width:calc(100%-160px);max-width:772px;display:flex;flex-direction:column;", " min-height:550px;padding-top:96px;padding-bottom:96px;box-sizing:border-box;& > .subtitle-header{max-width:unset;}@media screen and (max-width:768px){min-height:320px;height:unset;padding-top:48px;padding-bottom:48px;& > .subtitle-header{max-width:328px;}}"], function (props) {
  return props.small ? "" : "align-items: center;margin-left: auto;margin-right: auto;";
});
var LandingHeader = function LandingHeader(props) {
  return /*#__PURE__*/React__default.createElement(Div, {
    small: props.small,
    style: _objectSpread({}, props.style)
  }, props.ecosystem ? props.step ? /*#__PURE__*/React__default.createElement(LandingHeaderNormal, _extends({}, props, {
    step: true
  })) : /*#__PURE__*/React__default.createElement(LandingHeaderNormal, props) : props.small ? /*#__PURE__*/React__default.createElement(LandingHeaderSmall, props) : props.old ? /*#__PURE__*/React__default.createElement(LandingHeaderNormal$1, props) : /*#__PURE__*/React__default.createElement(LandingHeaderNormal$2, props));
};
export { LandingHeader as default };